import NewsCreatePage from './NewsCreatePage';

export default NewsCreatePage;
